import { AxiosError } from "axios";
import { ChatMessageRequest } from "src/entities/v3/ChatMessageRequest";
import { ChatMessageResponse } from "src/entities/v3/ChatMessageResponse";
import { usePost } from "./usePost";

interface Callbacks {
  onSuccess?: (data: ChatMessageResponse) => void;
  onError?: (err: AxiosError) => void;
  onStart?: () => void;
  onEnd?: () => void;
}

export const useChatMessage = () => {
  const { post, isLoading } = usePost<ChatMessageResponse>({
    url: `${process.env.REACT_APP_DOMAIN_V3}/api/v3/articles/chat/messages`,
  });

  const sendMessage = (params: ChatMessageRequest, callbacks?: Callbacks) =>
    post({
      params,
      onSuccess: callbacks?.onSuccess
        ? (data?: unknown) =>
            callbacks.onSuccess?.(data as ChatMessageResponse)
        : undefined,
      onError: callbacks?.onError,
      onStart: callbacks?.onStart,
      onEnd: callbacks?.onEnd,
    });

  return { sendMessage, isLoading };
};
